import { Divider, Pagination, Table, Tag } from "antd";
import { useEffect, useState } from "react";
import { FormOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getEnquiryData } from "./EnquiryApiFunction";
function EnquiryDetails() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPages] = useState();
  const [EnquiryData, setEnquiryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  function FetchEnquiryData() {
    setIsLoading(true);
    getEnquiryData(
      `?limit=10&page=${currentPage}${
        search && search.length ? `&search=${search}` : ""
      }`
    )
      .then((response) => {
        if (response.success) {
          setIsLoading(false);
          setEnquiryData(response.data.items);
          setTotalPages(response?.data?.pagination?.lastPage);
          setCurrentPage(response?.data?.pagination?.currentPage);
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchEnquiryData();
  }, [currentPage, search]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.name}
        </p>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.email}
        </p>
      ),
    },
    {
      title: "Contact",
      dataIndex: "mobile",
      key: "mobile",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.mobile}
        </p>
      ),
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.position}
        </p>
      ),
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.companyName}
        </p>
      ),
    },
    {
      title: "Identity",
      dataIndex: "identity",
      key: "identity",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.identity}
        </p>
      ),
    },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div className="ml-2  mt-6 mr-2">
        <div className=" mb-8 ">
          <Divider
            orientation="left"
            style={{ border: "#cecece" }}
            className="text-base tracking-normal font-dmsans font-normal  text-gray-900"
          >
            Enquiry Details
          </Divider>
          <div className="flex justify-center items-center gap-3">
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="text"
              placeholder="Type to search... "
              onChange={(e) => setSearch(e.target.value)}
            />
            <button
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="button"
              onClick={FetchEnquiryData}
            >
              Search
            </button>
          </div>
        </div>

        <div
          style={{ maxHeight: "620px", overflow: "auto" }}
          className="bg-white"
        >
          <Table
            columns={columns}
            dataSource={EnquiryData}
            className="w-screen sm:w-screen"
            loading={isLoading}
            pagination={false}
          />
        </div>
        <Pagination
          className="mt-2  flex justify-center items-center font-inter font-medium text-base w-full  h-[19px] "
          onChange={handlePageChange}
          current={currentPage}
          defaultCurrent={1}
          total={10 * totalPage}
          showSizeChanger={false}
        />
      </div>
    </>
  );
}
export default EnquiryDetails;
